import * as React from "react";
import { FlexDirectionFormGroupContextProvider } from "@generation/form";
import { ReadContainerProps } from "../Interfaces/ReadContainerProps";
import { SectionContainer } from "./SectionContainer";
import { DatasourcesContextProvider, FieldSchema } from "@generation/core";
import { DataContextProvider } from "@generation/overview-core";
import { CollapseContextProvider } from "../Context/Collapse/CollapseContextProvider";
import { ReadContainerPropsContextProvider } from "../Context/Read/ReadContainerPropsContextProvider";

export const ReadContainer = <TFieldSchema extends FieldSchema, TSchema extends Record<string, TFieldSchema>>(
  props: ReadContainerProps<TFieldSchema, TSchema>
): JSX.Element => {
  const flexDirectionFormGroupControl = props.uiDefaults?.flexDirectionFormGroupControl;

  return (
    <CollapseContextProvider>
      <DatasourcesContextProvider datasources={props.datasources ?? []}>
        <DataContextProvider value={props.values}>
          <ReadContainerPropsContextProvider value={props}>
            <FlexDirectionFormGroupContextProvider value={flexDirectionFormGroupControl}>
              <div className="formsection-container">
                {Object.entries(props.schema).map((sectie, index) => {
                  return (
                    <SectionContainer
                      name={sectie[0]}
                      field={sectie[1]}
                      key={`readcontainerprops_contextprovider_${index}`}
                      uiDefaults={props.uiDefaults}
                      renderAddedSchemaFields={props.renderAddedSchemaFields}
                    />
                  );
                })}
              </div>
            </FlexDirectionFormGroupContextProvider>
          </ReadContainerPropsContextProvider>
        </DataContextProvider>
      </DatasourcesContextProvider>
    </CollapseContextProvider>
  );
};
